module.exports = __webpack_public_path__ + "img/Flag_of_the_Bahamas.e66f1443.svg";